// extracted by mini-css-extract-plugin
export default {"mentionlegales":"MentionsLegales_mentionlegales__QGccJ","ml":"MentionsLegales_ml__7pzck"};